'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultButton = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('../../button');

var _button2 = _interopRequireDefault(_button);

require('../styles/DefaultButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prefer-stateless-function */
var DefaultButton = exports.DefaultButton = function (_React$Component) {
  _inherits(DefaultButton, _React$Component);

  function DefaultButton() {
    _classCallCheck(this, DefaultButton);

    return _possibleConstructorReturn(this, (DefaultButton.__proto__ || Object.getPrototypeOf(DefaultButton)).apply(this, arguments));
  }

  _createClass(DefaultButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className,
          _props$children = _props.children,
          children = _props$children === undefined ? '' : _props$children,
          _props$spinnerColor = _props.spinnerColor,
          spinnerColor = _props$spinnerColor === undefined ? '' : _props$spinnerColor,
          props = _objectWithoutProperties(_props, ['className', 'children', 'spinnerColor']);

      var classNames = 'cp-default-btn btn-default ' + className;

      return _react2.default.createElement(
        _button2.default,
        _extends({ className: classNames, spinnerColor: spinnerColor }, props),
        children
      );
    }
  }]);

  return DefaultButton;
}(_react2.default.Component);

DefaultButton.propTypes = {
  className: _react2.default.PropTypes.string,
  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
  spinnerColor: _react2.default.PropTypes.string,
  dataKey: _react2.default.PropTypes.string
};
DefaultButton.displayName = 'DefaultButton';

exports.default = DefaultButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-buttons/lib/components/default/components/DefaultButton.component.js
// module id = 409
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 14